<template lang="pug">
    .main_popup(@click="main_popup_click" :class="{blur: hideBurger}")
        .back(v-if="isMobileDevice" @click="$router.replace('/#history'), $store.commit('openPopup', 'periodPopup')")
        .left_side
            .side_inner
                .slide_info(v-if="!isMobileDevice")
                    .date
                        span(v-html="eventInfo.date")
                    .title(v-html="eventInfo.title")
                .swiper-container
                    .swiper-wrapper(@click="isMobileDevice ? infoPopup={type:'slider', content: eventInfo.slides, currentSlide:slider.realIndex} : ''")
                        .swiper-slide(v-for="slide in eventInfo.slides"
                            :style="{backgroundImage: 'linear-gradient(to bottom, transparent 50%, black 100%), url('+slide.VALUE+')'}")
                            .details(v-if="!isMobileDevice")
                                .details__text(v-if="slide.DESCRIPTION" v-html="slide.DESCRIPTION")

                    .swiper-pagination(data-hover)
        .right_side
            .side_inner
                .slide_info(v-if="isMobileDevice")
                    .date
                        span(v-html="eventInfo.date")
                    .title(v-html="eventInfo.title")
                .content
                    Closer(v-if="!isMobileDevice" @click.native="$store.commit('closePopup'), $router.replace('/#history')" data-hover)
                    .textWrapper(ref="text" v-html="eventInfo.text")
                    .back_btn(v-if="isMobileDevice" @click="$router.replace('/#history'), $store.commit('openPopup', 'periodPopup')") Назад

        video-player(ref="videoPlayer"
            data-hover
            v-show="wordsPopups_opening"
            :options="playerOptions"
            :playsinline="true")

        transition(name="showInfoPopup")
            InfoPopup(v-if="infoPopup" :info="infoPopup" @close="infoPopup=null")
</template>

<script>
    import InfoPopup from '@/components/popups/InfoPopup'

    export default {
        name: "MainPopup",
        props: ['eventInfo'],
        data: () => ({
            wordsPopups_opening: false,
            slider: null,
            playerOptions: {
                height: '360',
                autoplay: false,

                language: 'ru',
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [{
                    type: "video/mp4",
                    src: "",
                }],
            },

            infoPopup: null,
        }),
        computed: {
            isMobileDevice() {
                return this.$store.state.isMobileDevice;
            },
            hideBurger() {
                return this.$store.state.hideBurger
            },
        },
        methods: {
            initSlider() {
                this.slider = new Swiper('.main_popup .side_inner .swiper-container', {
                    speed: 500,
                    loop: true,
                    // effect: 'fade',
                    // fadeEffect: {
                    //     crossFade: true
                    // },
                    pagination: {
                        el: '.main_popup .side_inner .swiper-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                });
            },

            initWordsPopups() {
                this.eventInfo.wordsPopups.forEach(el => {
                    let word = document.querySelector('.' + el.id);
                    if (!word) return
                    word.classList.add('active');
                    word.classList.add(el.type);
                    let mini_popup_html;
                    let pos = this.getPosition(word);
                    if (el.type === 'person') {
                        mini_popup_html = `<div class="mini_popup person" style="${pos.x} ${pos.y}">`
                            +(el.content.link?`<div class="img" style="background-image: url(${el.content.link})"></div>`:'')+
                            `<div class="right">
                                <div class="rightWrapper">
                                    <div class="title">${el.content.name} <br>${el.content.date}</div>
                                    <div class="p_text">${el.content.text}</div>
                                </div>
                                <Closer/>
                            </div>
                        </div>`;
                    } else if (el.type === 'video') {
                        mini_popup_html = `<div class="mini_popup video" style="${pos.x} ${pos.y}"></div>`
                    }
                    word.insertAdjacentHTML('beforeEnd', mini_popup_html);

                    let mini_popup = word.querySelector('.mini_popup');

                    word.addEventListener('mouseover', (e) => {
                        if (e.target.matches('span.active') && !e.target.querySelector('.mini_popup.show')) {
                            this.closeMiniPopups();
                            this.wordsPopups_opening = true;
                            if (el.type === 'video') {
                                this.playerOptions.techOrder = ~el.content.link.indexOf('youtu') ? ['youtube'] : ['html5'];
                                this.playerOptions.sources[0].type = ~el.content.link.indexOf('youtu') ? 'video/youtube' : 'video/mp4';
                                this.playerOptions.sources[0].src = el.content.link;

                                /*this.playerOptions.tracks = [{
                                    kind:'captions',
                                    src: '/srtsample.vtt',
                                    srclang:'en',
                                    label:'English',
                                    default: true,
                                }];*/

                                let videoPopup = document.querySelector('.video-player');
                                mini_popup.insertAdjacentElement('beforeEnd', videoPopup)
                            } else if (el.type === 'person') {
                                $('.' + el.id + ' .rightWrapper').mCustomScrollbar();
                            }
                            mini_popup.classList.add('show');
                        }
                    })
                })
            },
            initMobileWordsPopups() {
                this.eventInfo.wordsPopups.forEach(el => {
                    let word = document.querySelector('.' + el.id);
                    word.classList.add('active');

                    word.addEventListener('click', (e) => {
                        this.infoPopup = el;
                        console.log(el);
                    })
                })
            },
            getPosition(word) {
                let x, y;
                let word_offset = {
                    x: word.offsetLeft,
                    y: this.getOffsetSum(word).top,
                };
                let textWidth = this.$refs.text.offsetWidth;
                let textHeight = this.$refs.text.offsetHeight;

                if (word_offset.x / textWidth < 0.5) {
                    x = `left: 1%;`
                } else if (word_offset.x / textWidth < 0.8) {
                    //x = `left: ${-word_offset.x / textWidth * 100}%;`
                    x = `right: 1%;`
                } else {
                    //x = `left: ${word_offset.x / textWidth * 100}%;`
                    x = `right: 1%;`
                }
                // this.$refs.text.getBoundingClientRect().top - расстояние от верха экрана до текста
                if (word_offset.y - this.$refs.text.getBoundingClientRect().top > textHeight / 2) {
                    if (!word.classList.contains('person')) {
                        y = `bottom: ${word.parentElement.offsetHeight - word.offsetTop + 5}px`;
                    } else {
                        y = `bottom: 100%`;
                    }
                } else {
                    if (!word.classList.contains('person')) {
                        y = `top: ${word.offsetTop + word.offsetHeight + 5}px`
                    } else {
                        y = `top:100%`
                    }
                }

                return {x, y};
            },
            getOffsetSum(elem) {
                var top = 0, left = 0
                while (elem) {
                    top = top + parseFloat(elem.offsetTop)
                    left = left + parseFloat(elem.offsetLeft)
                    elem = elem.offsetParent
                }
                return {top: Math.round(top), left: Math.round(left)}
            },
            closeMiniPopups() {
                this.wordsPopups_opening = false;
                Array.prototype.forEach.call(document.querySelectorAll('.mini_popup'), (el) => {
                    let video = document.querySelector('.mini_popup video');
                    if (video) {
                        video.pause();
                    }
                    if (el.classList.contains('show')) {
                        el.classList.remove('show');
                    }
                })
            },
            main_popup_click(e) {
                if (!e.target.closest('.mini_popup')) {
                    this.closeMiniPopups();
                }
            }
        },
        beforeDestroy() {
            this.closeMiniPopups()
        },
        mounted() {
            setTimeout(() => {
                this.initSlider();
                if (!this.isMobileDevice) {
                    $('.main_popup .right_side .textWrapper').mCustomScrollbar();
                }
            });
            setTimeout(() => {
                if (!this.isMobileDevice) {
                    this.initWordsPopups()
                } else {
                    this.initMobileWordsPopups()
                }
            }, 500);

        },
        components: {
            InfoPopup
        }
    }
</script>


<style lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_mixins.scss";

    .swiper-pagination {
        bottom: 9.7vh !important;
        width: 64% !important;
        pointer-events: none;

        .swiper-pagination-bullet {
            margin: 0 6px;
            border: 1px solid #fff;
            opacity: 1;
            background: none;
            outline: none;
            pointer-events: all;
        }

        .swiper-pagination-bullet-active {
            background: #fff;
        }
    }


    .mini_popup {
        position: absolute;
        z-index: 100;
        font-family: 'Fira Sans Extra Condensed', sans-serif;
        background: #fff;
        transition: .5s;
        display: none;

        &.show {
            display: flex;
        }

        &.person {
            max-height: 40vh;
            width: 18.6rem;
            color: $black;
            font-weight: 500;

            .img {
                min-width: 33%;
                background: no-repeat center top /contain;
            }

            .right {
                position: relative;
                display: flex;
                flex-direction: column;
                width: 100%;
                padding: 0.8rem 0 0.8rem 0.8rem;
                line-height: 1.3;
                text-align: left;
                .rightWrapper{
                    height: 100%;
                }
                .mCSB_container {
                    padding-right: 0.85rem;
                }

                .mCSB_scrollTools {
                    right: 0;
                }
            }

            .title {
                margin-bottom: 0.2rem;
                font-size: to_rem(17px);
            }

            .p_text {
                font-size: to_rem(13px);
            }
        }

        &.video {
            .video-player {
                position: static;
                top: 0;
                left: 0;
                cursor: pointer;
            }

            .video-js {
                //width: 38rem;
                //height: 21.5rem;
                width: 31.67vw;
                height: 17.92vw;

                .vjs-big-play-button {
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }

        }
    }

    .main_popup {
        position: fixed;
        top: 0;
        left: 0;
        width: 130vw;
        margin-left: -15vw;
        height: 100vh;
        z-index: 50;
        display: flex;
        color: #fff;

        .video-player { // Пока он не находится ни в одном видосе
            position: absolute;
            top: 10000px;
            left: 10000px;

            iframe {
                pointer-events: none;
            }
        }

        .left_side, .right_side {
            height: 100%;
            transform: skewX(-28.4deg) translate3d(0, 0, 0);
            overflow: hidden;
        }

        .left_side {
            width: 47.5%;
            background: #ccc;
            cursor: none;

            .side_inner {
                position: relative;
                transform-origin: top;
            }

            .swiper-container, .swiper-wrapper, .swiper-slide {
                height: 100%;
            }

            .swiper-slide {
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: flex-start;
                padding-bottom: 16vh;
                background: no-repeat center center / cover;
            }

            .details {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                height: 55vh;
                padding: 25vh 0 0 7vw;
                user-select: none;

                .details__text {
                    max-width: 50%;
                    padding: 1rem;
                    background: rgba(#fff, 0.6);
                    color: #000;
                    font-family: 'Fira Sans Extra Condensed', sans-serif;
                    font-size: to_rem(14px);
                    line-height: to_rem(20px);
                    opacity: 0;
                    transition: .3s;
                }

                &:hover .details__text {
                    opacity: 1;
                }
            }
        }

        .right_side {
            width: 52.5%;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            padding-top: 11.7vh;
            padding-right: 10.3%;
            background-image: linear-gradient(27deg, rgb(0, 34, 119) 0%, rgb(15, 82, 182) 60%, rgb(30, 130, 245) 100%);
            font-family: 'Fira Sans Extra Condensed', sans-serif;

            .side_inner {
                max-width: 48.8vw;
            }

            .content {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                height: 80vh;
                width: 100%;

            }

            .mCSB_inside > .mCSB_container {
                margin: 0;
                min-height: 99%;
            }

            .mCSB_scrollTools {
                right: 4vw;
            }

            .textWrapper {
                height: 100%;
                width: 100%;
                line-height: 1.4;
                letter-spacing: 0.3px;

                .active {
                    display: inline-block;
                    margin: 0 5px;

                    & > span {
                        position: relative;
                        display: inline-block;
                        z-index: 1;
                        pointer-events: none;

                        &:before {
                            content: '';
                            display: block;
                            position: absolute;
                            top: 4%;
                            left: -4px;
                            right: -6px;
                            bottom: 2%;
                            z-index: -1;
                            background: $red;
                            transform: skewX(-12deg);
                        }
                    }

                    &.person {
                        position: relative;
                    }
                }

                .mCSB_container > .text {
                    height: 100%;
                    padding-right: 6vw;
                    padding-left: 10vw;
                }
                .text .text{
                    position: relative;
                }
            }

            .close-button {
                margin-right: 6vw;
            }

            p {
                position: relative;
                margin-bottom: 0.5vh;
                font-size: 1rem;
                text-align: justify;
            }

            blockquote {
                position: relative;
                margin: 0;

                padding: 0.8rem 3.1rem 1.8rem;
                font-size: to_rem(18px);
                font-weight: 300;
                font-style: italic;

                &:before, &:after {
                    content: '';
                    display: block;
                    position: absolute;
                    width: 2.3rem;
                    height: 2.3rem;
                    background: url(../../assets/img/quotes.png) no-repeat center center / contain;
                }

                &:before {
                    top: 0;
                    left: 0;
                }

                &:after {
                    bottom: 1.6rem;
                    right: 0.2rem;
                    transform: rotate(180deg);
                }
            }
            ul, li{
                list-style: initial;
            }

            li {
              list-style-position: inside;
            }
        }

        .side_inner {
            height: 100%;
            transform: skewX(28.4deg);
        }

        .slide_info {
            position: absolute;
            left: 0;
            bottom: 16vh;
            z-index: 12;
            pointer-events: none;

            .title, .date {
                padding-left: 7.6vw;
                text-transform: uppercase;
                user-select: none;
            }

            .title {
                min-height: 15vh;
                max-width: 37vw;
                font-size: to_rem(41.5px);
                line-height: 1.16;
            }

            .date {
                position: relative;
                display: inline-block;
                margin-bottom: 1.8vh;
                font-size: to_rem(21px);

                span {
                    position: relative;
                    z-index: 1;
                }

                &:before {
                    content: '';
                    display: block;
                    position: absolute;
                    top: to_rem(-4px);
                    left: 0;
                    right: to_rem(-17px);
                    bottom: to_rem(-4px);
                    transform: skewX(-27deg);
                    background: #0d50ae;
                }
            }
        }
    }

    @include razr1280 {
        .main_popup {
            width: 140vw;
            margin-left: -20vw;

            .right_side {
                padding-right: 12.3%;
            }
        }
    }

    .mobile {
        .main_popup {
            display: block;
            width: 100vw;
            margin-left: 0;
            overflow: auto;

            &.blur {
                .left_side, .right_side {
                    filter: blur(15px);
                }
            }

            .left_side, .right_side {
                transform: initial;
                width: 100%;
                height: initial;
                overflow: initial;
            }

            .left_side {
                height: 83vh;

                .swiper-pagination {
                    bottom: 30vw !important;
                    width: initial !important;
                    margin-left: 1vw;
                }

                .swiper-pagination-bullet {
                    width: 1.9vw;
                    height: 1.9vw;
                    margin: 0 2.4vw !important;
                }
            }

            .right_side {
                position: relative;
                z-index: 1;
                margin-top: -26vw;
                padding: 0;
                background-image: linear-gradient(27deg, rgb(0, 34, 119) 0%, rgb(15, 82, 182) 70%, transparent 70%, transparent 100%);

                &:before {
                    content: '';
                    display: block;
                    position: absolute;
                    top: 5vw;
                    left: 0;
                    right: 0;
                    bottom: 20vw;
                    z-index: -1;
                    transform: skewY(-22deg);
                    background-image: linear-gradient(27deg, rgb(0, 34, 119) 0%, rgb(15, 82, 182) 60%, rgb(30, 130, 245) 100%);
                }

                .side_inner {
                    max-width: 100%;
                }

                .content {
                    height: initial;
                    padding: 0 3.6vw;
                    font-size: 4.8vmin;
                }

                p {
                    margin-bottom: 0;
                    font-size: 4.1vw;
                    line-height: 1.55;
                }

                blockquote {
                    margin: 7vw 0 9vw;
                    padding: 0 7vw 0 7vw;
                    font-size: 4.1vw;
                    line-height: 1.55;

                    &:before, &:after {
                        width: 6.5vw;
                        height: 5vw;
                    }

                    &:after {
                        bottom: 0;
                        right: 0;
                    }
                }
            }

            .slide_info {
                position: static;
                margin-bottom: 9vw;
                font-family: Pobeda, Arial;

                .title {
                    position: relative;
                    max-width: 100vw;
                    min-height: initial;
                    padding-left: 3.6vw;
                    font-size: 10.1vw;
                    font-weight: bold;
                    line-height: 1.057;
                }

                .date {
                    padding: 1vw 0 0.4vw 3.6vw;
                    font-size: 4.2vw;
                    font-weight: bold;

                    &:before {
                        top: -0.5vw;
                        left: -3vw;
                        right: -4vw;
                        bottom: -0.5vw;
                    }
                }
            }

            .side_inner {
                transform: initial;
            }
        }

        .back_btn {
            position: relative;
            z-index: 1;
            margin: 9vw auto 20vh;
            text-transform: uppercase;
            font-family: Pobeda, Arial;
            font-size: 5.2vmin;
            font-weight: bold;
            color: #fff;
            padding: 2.4vmin 23vmin 2.5vmin;
            white-space: nowrap;
            letter-spacing: 1px;

            &:before {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: -22%;
                z-index: -1;
                background: url(../../assets/img/nav_concurs_bg.png) no-repeat center center / 100% 100%;
            }
        }

        .back {
            position: fixed;
            top: 46vh;
            left: 0;
            z-index: 10;
            width: 7vw;
            height: 18vw;
            background: url(../../assets/img/button_back.png) no-repeat left top/contain;
        }

        .swiper-pagination .swiper-pagination-bullet {
            width: 2vw;
            height: 2vw;
            margin: 0 2vw;
        }
    }


    .showInfoPopup-enter {
        opacity: 0;

        .content {
            transform: translateY(3%);
        }
    }

    .showInfoPopup-enter-active {
        transition: opacity .4s;

        .content {
            transition: .4s;
        }
    }

    .showInfoPopup-leave-active {
        opacity: 0;
        transition: .5s;
    }
</style>
